export type FileType = 'pdf_pro' | 'pdf_ultra' | 'word'

export interface FileMaxRule {
  maxParsePage: number | 'unlimited'
  fileSize: number
  batchUploadCount: number
  fileSaveDay: number
  fileParseSpeed: number
}

export type BenefitsMatrix = Record<ServerDataTypes.VersionType, Record<FileType, FileMaxRule>>

export const BENEFITS_MATRIX: BenefitsMatrix = {
  free: {
    pdf_pro: { maxParsePage: 10, fileSize: 5, batchUploadCount: 1, fileSaveDay: 7, fileParseSpeed: 3 },
    pdf_ultra: { maxParsePage: 10, fileSize: 5, batchUploadCount: 1, fileSaveDay: 7, fileParseSpeed: 3 },
    word: { maxParsePage: 10, fileSize: 5, batchUploadCount: 1, fileSaveDay: 7, fileParseSpeed: 3 },
  },
  pro: {
    pdf_pro: { maxParsePage: 100, fileSize: 50, batchUploadCount: 1, fileSaveDay: 30, fileParseSpeed: 10 },
    pdf_ultra: { maxParsePage: 100, fileSize: 50, batchUploadCount: 30, fileSaveDay: 30, fileParseSpeed: 10 },
    word: { maxParsePage: 'unlimited', fileSize: 20, batchUploadCount: 30, fileSaveDay: 30, fileParseSpeed: 10 },
  },
  'pro+': {
    pdf_pro: { maxParsePage: 500, fileSize: 100, batchUploadCount: 1, fileSaveDay: 30, fileParseSpeed: 10 },
    pdf_ultra: { maxParsePage: 500, fileSize: 100, batchUploadCount: 30, fileSaveDay: 30, fileParseSpeed: 10 },
    word: { maxParsePage: 'unlimited', fileSize: 50, batchUploadCount: 30, fileSaveDay: 30, fileParseSpeed: 10 },
  },
  max: {
    pdf_pro: { maxParsePage: 500, fileSize: 100, batchUploadCount: 1, fileSaveDay: 30, fileParseSpeed: 10 },
    pdf_ultra: { maxParsePage: 500, fileSize: 100, batchUploadCount: 30, fileSaveDay: 30, fileParseSpeed: 10 },
    word: { maxParsePage: 'unlimited', fileSize: 50, batchUploadCount: 30, fileSaveDay: 30, fileParseSpeed: 10 },
  },
  ultra: {
    pdf_pro: { maxParsePage: 1500, fileSize: 300, batchUploadCount: 1, fileSaveDay: 180, fileParseSpeed: 20 },
    pdf_ultra: { maxParsePage: 1500, fileSize: 300, batchUploadCount: 100, fileSaveDay: 180, fileParseSpeed: 20 },
    word: {
      maxParsePage: 'unlimited',
      fileSize: 300,
      batchUploadCount: 100,
      fileSaveDay: 180,
      fileParseSpeed: 20,
    },
  },
}

export function getPlanFileMaxRule(
  version: ServerDataTypes.VersionType,
  feature: FileType
): FileMaxRule {
  const v = BENEFITS_MATRIX[version]
  return v[feature] as FileMaxRule
}
